import React, { forwardRef } from 'react';

import { InputProps } from '../types';

const FormControl = forwardRef<HTMLElement, InputProps>(
	({ 'aria-invalid': ariaInvalid = false, isInvalid, className, as: Wrapper = 'input', ...props }, ref) => {
		const classes = ['form-control', isInvalid && 'is-invalid', className].filter(Boolean).join(' ');
		return <Wrapper aria-invalid={isInvalid || ariaInvalid} className={classes} ref={ref} {...props} />;
	}
);

FormControl.displayName = 'FormControl';

export default FormControl;
